<template>
  <section class="manifesto" id="manifest">
    
    <img class="manifesto__img manifesto__img--desktop" :src="`https://api.rewolucyjna.pl/cms/${content.data.manifesto.img_desk}`" alt="maifest"
        />
    <img class="manifesto__img manifesto__img--mob" :src="`https://api.rewolucyjna.pl/cms/${content.data.manifesto.img_mob}`"  alt="maifest"
        />
    <Button v-bind:text='content.data.manifesto.btn' type="scroll" />
  </section>
</template>

<script>
import Button from '../elements/Button';
export default {

  name: "Manifest",
  components: {
    Button,
  },
  inject: ['content'],
};
</script>
